import common from '@/mixins/common';
import bem from './bem';
export default function(sfc) {
  sfc.name = `avue-echart-${sfc.name}`
  sfc.mixins = sfc.mixins || [];
  sfc.mixins.push(common, bem);
  return sfc;
}